<a *ngIf="auth.hasAll('RIGHT_CS_SYS_HELP_READ_DOCUMENTATION')" hisImage="LINK_EXTERN" class="documentationLink" target="_blank" 
	href="../../pages/cs/sys/portal/documentation/documentation.faces?
	navigationPosition=documentation&{{target}}"
	title="{{title | hisUi}}">{{'de.his.portal.doku' | hisUi}}</a>
	
	
	